import { useId } from "react";
import { Slot } from "@radix-ui/react-slot";

interface FieldProps extends React.ComponentProps<"div"> {
  label: string;
  error?: string;
}
export function Field({ label, error, ...props }: FieldProps) {
  const id = useId();
  return (
    <div {...props}>
      <label htmlFor={id} className="block mb-1 text-sm font-alternative">
        {label}
      </label>
      <Slot id={id}>{props.children}</Slot>
      {error && <em>{error}</em>}
    </div>
  );
}
